import { render, staticRenderFns } from "./MemberPlans.vue?vue&type=template&id=428a4f97"
import script from "./MemberPlans.vue?vue&type=script&lang=js"
export * from "./MemberPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports